<template>
  <div class="d-flex justify-content-around w-100">
    <div style="width: 30%" class="text-center">
      <a @click="showMultiple(0)">
        <img :data-src="require(`/src/assets/img/сertificates/423x544_12.jpg`)"
             :src="require(`/src/assets/img/loading.gif`)"
             class="img-thumbnail shadow"
             style="width: 100%"
        />
      </a>
    </div>
    <div style="width: 30%" class="text-center">
      <a @click="showMultiple(1)">
        <img :data-src="require(`/src/assets/img/сertificates/423x544_10.jpg`)"
             :src="require(`/src/assets/img/loading.gif`)"
             class="img-thumbnail shadow"
             style="width: 100%"
        />
      </a>
    </div>
    <div style="width: 30%" class="text-center">
      <a @click="showMultiple(2)">
        <img :data-src="require(`/src/assets/img/сertificates/423x544_8.jpg`)"
             :src="require(`/src/assets/img/loading.gif`)"
             class="img-thumbnail shadow"
             style="width: 100%"
        />
      </a>
    </div>
  </div>

  <vue-easy-lightbox
    scrollDisabled
    escDisabled
    :moveDisabled="false"
    :loop="true"
    :visible="visible"
    :imgs="imgs"
    :index="index"
    @hide="handleHide"
  ></vue-easy-lightbox>
</template>

<script>
export default {
  name: "Certificates",
  data() {
    return {
      imgs: "", // Img Url , string or Array of string
      visible: false,
      index: 0 // default: 0
    };
  },
  methods: {
    showMultiple(index) {
      this.imgs = [
        {
          src: require(`/src/assets/img/сertificates/1.jpeg`)
        },
        {
          src: require(`/src/assets/img/сertificates/3.jpeg`)
        },
        {
          src: require(`/src/assets/img/сertificates/5.jpeg`)
        }
      ];
      this.index = index; // index of imgList
      this.show();
    },
    show() {
      this.visible = true;
    },
    handleHide() {
      this.visible = false;
    }
  }
};
</script>

<style scoped></style>
